(function() {
  let highestPricePerCheck = 0;

  function calculatePricePerCheck(price, quantity) {
    return (price / quantity).toFixed(3);
  }

  function calculatePercentSavings(currentPricePerCheck) {
    if (highestPricePerCheck === 0) return 0;
    return ((highestPricePerCheck - currentPricePerCheck) / highestPricePerCheck * 100).toFixed(1);
  }

  function updatePriceAndSavings() {
    const priceElement = document.querySelector('.price--sale .money, .price .money');
    const quantityElement = document.querySelector('.swatch input[name="option-0"]:checked');
    const pricePerCheckElement = document.querySelector('.price-per-check .money');
    const percentSavingsElement = document.querySelector('.percent-savings .savings-value');

    if (priceElement && quantityElement && pricePerCheckElement && percentSavingsElement) {
      const price = parseFloat(priceElement.getAttribute('data-price') || priceElement.textContent.replace(/[^0-9.]/g, ''));
      const quantity = parseInt(quantityElement.value);
      
      if (!isNaN(price) && !isNaN(quantity) && quantity > 0) {
        const pricePerCheck = parseFloat(calculatePricePerCheck(price, quantity));
        pricePerCheckElement.textContent = `$${pricePerCheck.toFixed(3)}`;

        // Update highest price per check if necessary
        if (pricePerCheck > highestPricePerCheck) {
          highestPricePerCheck = pricePerCheck;
        }

        const percentSavings = calculatePercentSavings(pricePerCheck);
        percentSavingsElement.textContent = percentSavings;

        // Show/hide percent savings based on whether there are actual savings
        const savingsContainer = document.querySelector('.percent-savings');
        if (percentSavings > 0) {
          savingsContainer.style.display = 'inline-block';
        } else {
          savingsContainer.style.display = 'none';
        }
      }
    }
  }

  function initializePriceAndSavings() {
    updatePriceAndSavings();
    // Watch for changes in the variant selector
    const variantSelector = document.querySelector('select[name="id"], input[name="id"]');
    if (variantSelector) {
      variantSelector.addEventListener('change', function() {
        setTimeout(updatePriceAndSavings, 100);
      });
    }
    // Watch for changes in quantity swatches
    const quantitySwatches = document.querySelectorAll('.swatch input[name="option-0"]');
    quantitySwatches.forEach(swatch => {
      swatch.addEventListener('change', function() {
        setTimeout(updatePriceAndSavings, 100);
      });
    });
    // Watch for price changes
    const priceContainer = document.querySelector('.price--sale, .price');
    if (priceContainer) {
      const observer = new MutationObserver(() => {
        updatePriceAndSavings();
      });
      observer.observe(priceContainer, { subtree: true, characterData: true, childList: true });
    }
    // Re-run on Shopify's currency change event
    document.addEventListener('currency.changed', updatePriceAndSavings);
  }

  // Run the initialization when the DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePriceAndSavings);
  } else {
    initializePriceAndSavings();
  }

  // Make initializePriceAndSavings available globally
  window.initializePriceAndSavings = initializePriceAndSavings;
})();


// // Check Number Validation for Bold Options
// BOLD.options.app.on('options_loaded', function(event) {
//   var inputSelectors = [
//     'input[name="properties[Check Starting Number]"]',
//     'input[name="properties[New Check Starting Number]"]'
//   ];


// Check Number Validation for Bold Options
// Guard: BOLD.options.app is undefined when the SC/Bold app embed fails to load.
// Falls back to a no-op so the rest of custom.js still runs.
var boldOptionsApp = (window.BOLD && BOLD.options && BOLD.options.app &&
                      typeof BOLD.options.app.on === 'function')
  ? BOLD.options.app
  : { on: function () {} };

boldOptionsApp.on('options_loaded', function(event) {
  var inputSelectors = [
    'input[name="properties[Check Starting Number]"]',
    'input[name="properties[New Check Starting Number]"]'
  ];

  inputSelectors.forEach(function(selector) {
    var input = document.querySelector(selector);
    
    if (input) {
      input.addEventListener('input', function(e) {
        var value = e.target.value.replace(/^0+/, '');
        e.target.value = value;
        
        // Trigger Bold's change event
        var event = new Event('change', { bubbles: true });
        this.dispatchEvent(event);
      });

      input.addEventListener('blur', function(e) {
        if (e.target.value === '') {
          e.target.value = '1';
          
          // Trigger Bold's change event
          var event = new Event('change', { bubbles: true });
          this.dispatchEvent(event);
        }
      });
    }
  });
});

// Scroll Animation for Homepage Sections
document.addEventListener('DOMContentLoaded', function() {
  // Only run on homepage (adjust selector for your theme if needed)
  if (!window.location.pathname.match(/^\/(index\.html)?$/)) return;

  // Only run on desktop
  if (window.innerWidth < 1024) return;

  var elements = document.querySelectorAll('.scroll-fade-in');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // Animate only once
        }
      });
    }, { threshold: 0.15 });
    elements.forEach(function(el) { observer.observe(el); });
  } else {
    // Fallback: show all if IntersectionObserver not supported
    elements.forEach(function(el) { el.classList.add('is-visible'); });
  }
});